'use client';

import React from 'react';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';
import CaretIcon from '../../atoms/icons/caret';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

const CustomNavigation = () => {
  const swiper = useSwiper();

  return (
    <div className="absolute flex w-auto h-auto justify-between items-center bottom-4 right-4 z-50">
      <button
        className="z-50 rotate-90 rounded-full w-7 h-7 bg-yellow-60 hover:bg-yellow md:w-8 md:h-8 flex justify-center items-center"
        onClick={() => {
          swiper.slidePrev();
          swiper.autoplay.pause();
        }}
        aria-label="Previous"
      >
        <CaretIcon fill="#222222" />
      </button>
      <button
        className="z-50 -rotate-90 rounded-full w-7 h-7 bg-yellow-60 hover:bg-yellow md:w-8 md:h-8 flex justify-center items-center"
        onClick={() => {
          swiper.slideNext();
          swiper.autoplay.pause();
        }}
        aria-label="Next"
      >
        <CaretIcon fill="#222222" />
      </button>
    </div>
  );
};

const Slider = ({ blok }) => {
  return (
    <Swiper
      navigation={true}
      autoplay={
        blok.automaticSlide
          ? {
              delay: 4000,
              disableOnInteraction: true,
            }
          : false
      }
      loop={true}
      slidesPerView={1}
      modules={[Navigation, Autoplay]}
      key={blok._uid}
      lazy="true"
      lazyPreloadPrevNext={2}
      {...storyblokEditable(blok)}
      className={`w-full ${blok.className || ''}`}
    >
      {blok.blocks.map((slide, index) => (
        <SwiperSlide key={slide._uid}>
          <StoryblokComponent
            blok={slide}
            inSlider={true}
            itemSliderPosition={index}
          />
        </SwiperSlide>
      ))}
      {blok.blocks?.length > 1 && !blok.hide_navigation && <CustomNavigation />}
    </Swiper>
  );
};
export default Slider;
